export enum StatusEnum {
  ATIVA = "Ativa",
  INATIVA = "Inativa",
  CANCELADA = "Cancelada",
}
export enum StatusParcelaEnum {
  ATIVA = "Ativa",
  CANCELADA = "Cancelada",
  PAGA = "Paga",
  VENCIDA = "Vencida",
  REJEITADA = "Rejeitada",
}

export enum StatusRemessaEnum {
  ENVIAR = "Enviar",
  NAO_ENVIAR = "Nao enviar",
  ENVIADA = "Enviada",
}

export enum StatusRemessaBaixaEnum {
  ENVIAR = "Enviar",
  NAO_ENVIAR = "Nao enviar",
  ENVIADA = "Enviada",
}

export enum StatusImpressaoEnum {
  A_IMPRIMIR = 'A imprimir',
  IMPRESSO = 'Impresso',
  NAO_IMPRIMIR = 'Não imprimir',
  PENDENTE = 'Pendente',
}

export enum FormaPagamentoEnum {
  DINHEIRO = "Dinheiro",
  PIX = "PIX",
  CHEQUE = "Cheque",
  CARTAO_CREDITO = "Cartao de credito",
  CARTAO_DEBITO = "Cartao de debito",
  DEPOSITO = "Deposito",
  RETORNO = "Retorno",
}

export enum TipoCobrancaEnum {
  MENSALIDADE = "Mensalidade",
  ESPORADICA = "Esporádica",
}
